<template>
  <div class="text-left">
    <div v-if="!executing">
      <div class="text-small">
        Use this extra information that's specific to this event only, such as online joining details, etc.
        This information will not be copied when you clone an event or for events with repeats. The extra information
        visibility follows the venue visibility rules for the event.
      </div>
      <editor :init="editorConfig" v-model="editExtraInfo"/>
      <mdb-btn @click="doSave">
        <mdb-icon icon="save"/>
        Save
      </mdb-btn>
      <mdb-btn @click="doCancel">
        <mdb-icon icon="window-close"/>
        Cancel
      </mdb-btn>
    </div>
    <mdb-modal :show="showImageSelector" @close="showImageSelector = false">
      <mdb-modal-header :close="true" center class="secondary-color text-white">Select an Image</mdb-modal-header>
      <mdb-modal-body>
        <image-selector :group="currentGroup" @imageSelected="imageSelected" emitOnSelection="imageSelected"/>
      </mdb-modal-body>
    </mdb-modal>

  </div>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import editor from '@tinymce/tinymce-vue'
import {mdbBtn, mdbIcon, mdbInput, mdbModal, mdbModalBody, mdbModalHeader, mdbSelect} from 'mdbvue';
import imageSelector from '../group/ImageSelector'

export default {
  name: 'Event-Location-Editor',
  components: {
    mdbBtn,
    mdbIcon,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbSelect,
    mdbInput,
    imageSelector,
    editor
  },
  props: {
    extraInfo: {
      type: String,
      default: null
    },
    eventId: {
      type: Number,
      default: null
    }
  },
  computed: {
    userDetails() {
      return this.$store.state.userDetails
    },
    currentGroup() {
      return this.$store.state.currentGroup
    },
    executing() {
      return this.$store.state.executing
    }
  },
  data() {
    return {
      showImageSelector: false,
      editExtraInfo: this.extraInfo,
      editorConfig: {
        selector: '.tinymce_group_content',
        browser_spellcheck: true,
        branding: false,
        plugins: ["image", "link", "code", "paste", "table", "lists"],
        toolbar: ["undo redo cut copy paste bold italic underline numlist bullist fontsizeselect | alignleft alignright aligncenter | styleselect | image link unlink code "],
        file_picker_callback: this.myFileBrowser,
        image_advtab: true,
        style_formats_merge: true,
        paste_as_text: true,
        relative_urls: false,
        remove_script_host: false,
        height: 400,
        style_formats: [{
          title: 'Image Left',
          selector: 'img',
          styles: {
            'float': 'left',
            'margin': '0 10px 0 10px'
          }
        },
          {
            title: 'Image Right',
            selector: 'img',
            styles: {
              'float': 'right',
              'margin': '0 0 10px 10px'
            }
          },
          {
            title: 'GP Heading',
            block: 'div',
            classes: 'tile_title'
          }
        ]
      }
    }
  },
  methods: {
    doSave() {
      this.$store.dispatch("setExecuting", true);
      api.post("/event/venueExtraInfo/" + this.eventId, {extraInfo: this.editExtraInfo}).then(
        (results) => {
          this.$emit("saveExtraInfo", this.editExtraInfo)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    doCancel() {
      this.$emit("cancelExtraInfo")
    },
    imageSelected: function (image) {
      this.showImageSelector = false
      let el = document.getElementsByClassName("tox-dialog-wrap")
      el[0].setAttribute("style", "display:block")
      this.imageCallback(image.url, {width: "33%", height: ""})
    },
    myFileBrowser: function (callBack, value, meta) {
      let el = document.getElementsByClassName("tox-dialog-wrap")
      el[0].setAttribute("style", "display:none")
      this.showImageSelector = true
      this.imageCallback = callBack
    }
  }
}
;
</script>
